var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alert alert-info m-0 mb-6 expiration-message" },
    [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.$l10n.__(
              "Votre offre a été réalisée par un commercial Sellsy, certains éléments ne sont pas modifiables."
            )
          ) +
          "\n    "
      ),
      _c("span", { staticClass: "block bold" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Cette offre expire le")) +
            " " +
            _vm._s(
              _vm._f("dateFormatter")(_vm.expirationDate, "NORMAL_DATE", false)
            ) +
            "\n    "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }